<template>
  <div id="Kitora">
    <h1>{{ $t("Kitora.title") }}</h1>
    <section>
      <p class="msgText" v-html="$t('Kitora.text')"></p>
    </section>
    <div class="privacy-policy" v-html="$t('Common.PrivacyPolicy')"></div>
    <br>
    <br>
    <!-- システムメンテナンス告知文 -->
    <section>
      <p class="msgText"><B>System maintenance : </B></p>
      <p class="msgText" v-html="getSystemMsg"></p>
      <br>
      <br>
    </section>
    <!-- 認証エラーメッセージ -->
    <section v-if="no > 0">
      <p class="msgError"><B>Error : </B></p>
      <p class="msgError" v-html="getMsg"></p>
      <br>
      <br>
    </section>
    <button class="kitora-btn" v-on:click="kitoraEndPoint">{{ $t("Kitora.button") }}</button>
  </div>
</template>

<script>
export default {
  name: 'Kitora',
  data () {
    return {
      // 項目-初期値
      no: 0,
    }
  },


  /*
   * created: 初期処理
   */
  created : function(){
    // パラメータを取得
    this.no = this.$route.params.no;
//console.log(this.$route);
  },

  /*
   * mounted: elementへのマウント
   */
  mounted : function() {
  },

  /*
   * methods: メソッド
   */
  methods: {
    // Kitora認証画面へボタン押下
    kitoraEndPoint() {
        location.href = process.env.VUE_APP_KITORA_URL;
    },
  },

  /*
   * computed: 算出プロパティ
   */
  computed: {
    // KITORA権限チェックエラーメッセージ
    getMsg: function() {
      // エラー
      if (this.no !== 0) {
        return this.$t("Message.MSG007");
      }

      // エラーなし
      return "";
    },
    // システムメンテナンス告知文
    getSystemMsg: function() {
      return this.$t("Message.MSG008");
    },
  },
}
</script>
<style>
/*--------------------
    BASIC CLASSES
--------------------*/
#Kitora {
  max-width: 640px;
  margin: 0 auto;
}

/*--------------------
    FORM STYLING
--------------------*/
.kitora-btn {
  width: 200px;
  height: 30px;
  color: #000000;
  font-size: 20px;
  border: none;
  cursor: pointer;
  background: #0099e4;
}

.msgT {
  border: none;
}

.msgText {
  text-align: left;
  line-height: 22px;
  border: none;
}

.msgError {
  text-align: left;
  line-height: 22px;
  color: #ff0000;
  border: none;
}

.privacy-policy {
  border: 1px solid #000000;
  margin-top: 20px;
  padding: 20px;
  text-align: left;
}

.privacy-policy a {
  color: #000000;
}
</style>
